import { useState } from 'react';

const steps = [
  {
    number: '01',
    title: 'Diagnóstico Estratégico',
    description:
      'Realizamos uma análise profunda do contexto empresarial, identificando pontos críticos, oportunidades latentes e os principais desafios que impedem o crescimento sustentável da organização.',
  },
  {
    number: '02',
    title: 'Desenho da Solução',
    description:
      'Com base no diagnóstico, desenvolvemos soluções personalizadas e accionáveis, alinhadas com os recursos disponíveis e os objectivos estratégicos de curto, médio e longo prazo.',
  },
  {
    number: '03',
    title: 'Implementação Assistida',
    description:
      'Acompanhamos de perto a execução das soluções propostas, garantindo que cada etapa seja implementada com rigor, adaptando-nos às dinâmicas reais do negócio.',
  },
  {
    number: '04',
    title: 'Monitorização & Resultados',
    description:
      'Estabelecemos indicadores de desempenho claros e acompanhamos os resultados, assegurando que os objectivos sejam atingidos e que o valor criado seja sustentável.',
  },
];

export default function MethodologySection() {
  const [active, setActive] = useState(0);

  return (
    <section id="metodologia" className="bg-[#011820] py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          {/* Left — Image */}
          <div className="w-full lg:w-[45%] relative">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5]">
              <img
                src="https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/d0d139e4e618b2e47b94aeafdb896458.jpeg"
                alt="Metodologia MoveMind"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#011820]/60 to-transparent" />
            </div>

            {/* Floating card */}
            <div className="absolute -bottom-6 -right-4 md:right-0 bg-[#026A86] rounded-2xl p-5 max-w-[200px] shadow-xl">
              <div className="text-white text-3xl font-bold">98%</div>
              <div className="text-white/80 text-xs mt-1 leading-snug">
                Taxa de satisfação dos nossos clientes
              </div>
            </div>

            {/* Decorative */}
            <div className="absolute -top-6 -left-6 w-24 h-24 border border-[#026A86]/30 rounded-full" />
            <div className="absolute -top-3 -left-3 w-12 h-12 border border-[#026A86]/50 rounded-full" />
          </div>

          {/* Right — Content */}
          <div className="w-full lg:w-[55%]">
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="text-[#026A86] text-xs font-medium tracking-widest uppercase">
                (Nossa Metodologia)
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
              Metodologia da
              <br />
              <span className="text-[#026A86]">MoveMind</span>
            </h2>

            <p className="text-white/50 text-base leading-relaxed mb-10 max-w-lg">
              Uma abordagem estruturada e comprovada que combina rigor analítico com
              profundo conhecimento do mercado angolano e africano.
            </p>

            {/* Steps */}
            <div className="flex flex-col gap-4">
              {steps.map((step, idx) => (
                <button
                  key={step.number}
                  onClick={() => setActive(idx)}
                  className={`text-left rounded-xl p-5 border transition-all duration-300 cursor-pointer ${
                    active === idx
                      ? 'bg-[#026A86]/15 border-[#026A86]'
                      : 'bg-transparent border-white/10 hover:border-[#026A86]/40'
                  }`}
                >
                  <div className="flex items-start gap-4">
                    <span
                      className={`text-2xl font-bold transition-colors duration-300 ${
                        active === idx ? 'text-[#026A86]' : 'text-white/20'
                      }`}
                    >
                      {step.number}
                    </span>
                    <div>
                      <h3
                        className={`font-semibold mb-1 transition-colors duration-300 ${
                          active === idx ? 'text-white' : 'text-white/60'
                        }`}
                      >
                        {step.title}
                      </h3>
                      {active === idx && (
                        <p className="text-white/60 text-sm leading-relaxed">
                          {step.description}
                        </p>
                      )}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
